<template>
        <section class="welcome">
            <picture class="welcome__bg">
              <source media="(min-width: 520px)" srcset="/assets/front/img/main-page--welcome.png">

              <img src="/assets/front/img/main-page--welcome-mobile.png" alt="img">
            </picture>

            <div class="container welcome__container main-container registration-section__container">
                <div class="welcome__text ">
                    <h2 class="title title--m title--uppercase title--white welcome__title">
                        {{ $lang('mcWelcome.title')}}
                    </h2>

                    <div class="welcome__desc">{{ $lang('mcWelcome.desc')}}</div>
                </div>

                <div class="welcome__form shadow registration-form">
                    <div class="registration-form__header">
                        <span class="title title--sm popup__title registration-form__header-title">{{ $lang('registration.title') }}</span>
                    </div>

                    <errors :errors="errors"></errors>
                    <form class="form" @submit.prevent="registerPost">
                        <div class="form__item form__item--inline registration__form-item">
                            <label class="form__inner registration-form__inner">
                                <el-input class="input input--big" :placeholder="$lang('feedback.name.placeholder')" v-model="formAuth.name" required dusk="name"></el-input>
                            </label>
                        </div>
                        <div class="form__item form__item--inline registration__form-item">
                            <label class="form__inner registration-form__inner">
                                <el-input class="input input--big" placeholder="E-mail" v-model="formAuth.email" dusk="email"></el-input>
                            </label>
                        </div>
                        <div v-if="locale === 'ru'" class="form__item form__item--inline registration__form-item">
                            <label class="form__inner registration-form__inner">
                                <input-phone v-model="formAuth.phone" placeholder="Телефон" class="input input--big"/>
                            </label>
                        </div>
                        <div class="form__item registration__form-item">
                            <el-checkbox v-model="formAuth.checked" required dusk="checkbox">
                                {{ $lang('registration.policy.part1') }}
                                <a class="el-checkbox__link" target="_blank" href="/assets/front/pdf/memorycode_processing_of_personal_data.pdf">
                                    {{ $lang('registration.policy.part2') }}
                                </a>
                            </el-checkbox>
                        </div>
                        <div class="form__item registration__form-item--mb24">
                            <button class="btn btn--middle btn--main-bg registration-form__btn" dusk="registration">{{ $lang('registration.button.reg') }}</button>
                        </div>
                        <div class="form__item form__item--inline registration-form__login">
                            <router-link class="link" :to="{name: 'login'}"><span>{{ $lang('discount.link.login') }}</span></router-link>
                        </div>
                    </form>
                </div>
            </div>
        </section>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Errors from "../error/errors";
import width from "../../mixins/width";
import InputPhone from "../../components/InputPhone";

export default {
    name: 'WelcomeRegistration',
    mixins: [width],
    components: {Errors, InputPhone},
    data: () => ({
        errors: null,
        showMessage: null,
        locale: window.laravel.locale
    }),
    computed: {
        ...mapState('auth',[
            'formAuth',
        ]),
    },
    methods: {
        ...mapActions('auth', [
            'register',
        ]),
        ...mapMutations('auth', [
            'clearData',
            'generatePassword',
        ]),
        registerPost() {
            this.generatePassword();
            this.formAuth.sendPassword = true;
            this.errors = null;

            this.$loading(this.$optionsLoading);

            this.register().then((response) => {
                this.$dataLayer.push({'event': 'createUser', 'user_id': response.data.user.id});

                if (response.data.user.hasOwnProperty('show_message')) {
                    this.$appNotify.success(response.data.user.show_message);

                    setTimeout(() => {
                        window.location.href = response.data.redirect
                    }, 3000);
                } else {
                    window.location.href = response.data.redirect;
                }
            }).catch((error) => {
                let data = error.response.data;

                if (data.hasOwnProperty('errors')) {
                    this.errors = data.errors;
                } else if (data.message) {
                    this.$appNotify.error(data.message);
                }
            }).finally(() => {
                this.$loading({}).close();
            });
        }
    },
    beforeDestroy() {
        this.$nextTick(() => {
            this.clearData();
        });
    },
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
.welcome {
    position: relative;

    @media (max-width: $screen-xl - 1) {
        background: $color-main;
        padding-top: 20rem;
    }
    @media (min-width: $screen-xl) {
        height: calc(75vh - 114px);
        min-height: 688px;
    }
}

.welcome__bg {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: cover;
    img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
}

.welcome__container {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 100%;
    @media (max-width: $screen-xl - 1) {
        flex-direction: column;
    }
    @media (min-width: $screen-xl) {
        align-items: center;
    }
}


.welcome__text {
    color: $white;
    max-width: 600px;
    @media (max-width: $screen-xl - 1) {
        margin-bottom: 5rem;
    }
}

.welcome__title {
    margin-bottom: 2.9rem;
    @media (max-width: $screen-md - 1) {
        font-size: 3.25rem;
    }
}

.welcome__desc {
    max-width: 460px;
    font-weight: 400;
    font-size: 1.8rem;
    line-height: 140%;
}

.welcome__form {
    max-width: 387px;
    width: 100%;
    padding: 3.7rem 4.4rem 2.5rem 4rem;
    background: $white;
}

.welcome__form-title {
    margin-bottom: 2.8rem;
}

.welcome__form-restore {
    padding-top: 2rem;
    padding-bottom: 3rem;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 140%;
}

.welcome__form-reg {
    border-top: 1px solid $gray--dark;
    padding-top: 2.2rem;
}

.registration__form-item:not(:last-child){
    margin-bottom: 1.8rem;
}

.registration__form-item--mb24 {
    margin-bottom: 2.4rem;
}
</style>
